import axios from "axios";
import moment from "moment/moment";
import tokenApi from "../../api/tokenApi";
import { SET_LOADING, SET_LOADING_FALSE, SET_LOADING_GRAPH } from "../constants/utilsConstants";
import { StatsConstant } from "../constants/statsConstant";
import { setAlert } from "./alert";
import { getValidDate } from "../../utils/formateDate";
import { each } from "@react-spring/shared";

const fetchEventById = async (id) => {
  const res = await tokenApi.get(`/eventbyid/${id}`);
  return res.data.event;
};

//Set Global filter

export const setGlobalFilter = (eventOrCompany, _searchText) => {
  return async (dispatch) => {
    if (eventOrCompany === null) {
      // make the stats by id to null
      dispatch({
        type: StatsConstant.RESET_FILTER,
      });
    }

    dispatch({
      type: StatsConstant.SET_GLOBAL_FILTER,
      payload: { eventOrCompany: eventOrCompany, searchText: _searchText },
    });
  };
};

export const setCompanyNameInTitle = (id) => {
  return async (dispatch) => {
    try {
      const eventRecord = await fetchEventById(id);
      const company = eventRecord.companies?.[0] || {};
      let companyId = company._id;
      let companyName = company.name;

      dispatch({
        type: StatsConstant.SET_COMPANY_ID_NAME,
        payload: { Cid: companyId, Cname: companyName },
      });
    } catch (error) {
      console.error(error);
      dispatch({
        type: StatsConstant.SET_ERROR,
        payload: error,
      });
    }
  };
};


export const setUserActivity = (id) => {
  return async (dispatch) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/event/userActivity/${id}/?token=${process.env.REACT_APP_TOKEN_BASE_API}`
      );

      console.log('USERACTIVITYUSERACTIVITY', res.data)
      if(res.data) {
        dispatch({
          type: StatsConstant.SET_USER_ACTIVITY,
          payload: res.data.userActivity,
        });
    
      }
  
    } catch (error) {
      console.error(error);
      dispatch({
        type: StatsConstant.SET_ERROR,
        payload: error,
      });
    }
  };
};


//Reg count per day (pre reg - post reg)

export const getRegCount = (id) => {
  return async (dispatach) => {

    dispatach({
      type: StatsConstant.SET_LOADING,
      payload: true,
    });
    try {

      const res = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/users/getRegistrantsCount/${id}/?token=${process.env.REACT_APP_TOKEN_BASE_API}`
      );

      dispatach({
        type: StatsConstant.GET_REG_COUNT_BY_EVENT,
        payload: { data: res.data },
      });
    } catch (error) {
      console.log(error);
      dispatach({
        type: StatsConstant.SET_ERROR,
        payload: error,
      });
    }
  };
};


export const getAllUserLocationNoReg = (id) => {
  return async (dispatch) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/event/getUserLocationNoReg/${id}/?token=${process.env.REACT_APP_TOKEN_BASE_API}`
      );

      console.log('getAllUserLocationNoReg', res.data?.location)
      if(res.data) {
        dispatch({
          type: StatsConstant.GET_USER_LOCATION_NO_REG,
          payload:res.data?.location,
        });
    
      }
  
    } catch (error) {
      console.error(error);
      dispatch({
        type: StatsConstant.SET_ERROR,
        payload: error,
      });
    }
  };
};

export const resetStats = () => {
  return async (dispatch) => {
    dispatch({
      type: StatsConstant.RESET_FILTER,
    });
  };
};

export const getEventByCompanyID = (id) => {
  return async (dispatch) => {
    try {
      const res = await tokenApi.get("/events-by-companies", {
        params: {
          companyIds: id,
          page: 1,
          pageSize: 100,
        },
      });

      const events = res.data.events || [];

      if (events.length === 0) {
        dispatch(setAlert("No events found", "error", 3000, "7rem"));
      }

      dispatch({
        type: StatsConstant.GET_EVENT_BASED_ON_COMPANY_ID,
        payload: { events, id },
      });
    } catch (error) {
      const data = error.response?.data;
      const message =
        (typeof data === "string" && data) ||
        data?.error ||
        "Could not load events for this company";

      dispatch(setAlert(message, "error", 3000, "7rem"));
      dispatch({
        type: StatsConstant.SET_ERROR,
        payload: message,
      });
    }
  };
};

export const getLiveUsersByEventID = (id) => {
  return async (dispatach) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/event/fetchLiveUsers/${id}/?token=${process.env.REACT_APP_TOKEN}`
      );

      const eventRecord = await fetchEventById(id);

      if (!eventRecord.registrationRequired) {
        console.log("Event with no Req", id);
        dispatach(getLiveUsersByEventIDNoReq(id));
      } else {
        dispatach({
          type: StatsConstant.GET_RT_STATS_BY_EVENTID,
          payload: res.data,
        });
      }
    } catch (error) {
      console.error(error);
      dispatach({
        type: StatsConstant.SET_ERROR,
        payload: error,
      });
    }
  };
};


export const getLiveUsersByEventID_SocketIO = (users) => {
  return async (dispatach) => {


    const newArray = users?.map((obj) => {
      const { socketID, userID, eventID, ...rest } = obj;
      return rest;
    });
    
    console.log('newArray', newArray);

    dispatach({
      type: StatsConstant.GET_RT_STATS_BY_EVENTID,
      payload:newArray
    });
  };
};





//Search Functionality

// Event title autocomplete. Matches enabled events whose title contains the text.
export const getEventByKeyStroke = (name) => {
  return async (dispatch) => {
    try {
      const res = await tokenApi.get("/events/search", {
        params: {
          page: 1,
          pageSize: 10,
          title: name,
        },
      });

      dispatch({
        type: StatsConstant.GET_EVENT_KEYSTROKE,
        payload: res.data,
      });
    } catch (error) {
      const data = error.response?.data;
      const message =
        (typeof data === "string" && data) ||
        data?.error ||
        "Event search failed";

      dispatch(setAlert(message, "error", 3000));
      dispatch({
        type: StatsConstant.SET_ERROR,
        payload: message,
      });
      dispatch({
        type: StatsConstant.GET_EVENT_KEYSTROKE,
        payload: { events: [] },
      });
    }
  };
};

// Company autocomplete. name_or_code matches company name, code, or collectionCode.
export const getCompaniesByKeyStroke = (name) => {
  return async (dispatch) => {
    try {
      const res = await tokenApi.get("/companies", {
        params: {
          page: 1,
          pageSize: 5,
          name_or_code: name,
        },
      });

      dispatch({
        type: StatsConstant.GET_COMPANY_KEYSTROKE,
        payload: res.data,
      });
    } catch (error) {
      const data = error.response?.data;
      const message =
        (typeof data === "string" && data) ||
        data?.error ||
        "Company search failed";

      dispatch(setAlert(message, "error", 3000));
      dispatch({
        type: StatsConstant.SET_ERROR,
        payload: message,
      });
      dispatch({
        type: StatsConstant.GET_COMPANY_KEYSTROKE,
        payload: { companies: [] },
      });
    }
  };
};

// Get events based on company
// https://api.brrmedia.co.uk/company/events/531d51203665390db7000c73/1/10/?token=587cf0af60c7bd46e301b2fc

// export const getStatByID = (id) => {

//     return async (dispatach) => {

//         dispatach({
//             type: StatsConstant.SET_LOADING,
//             payload: true
//         })

//         try {

//             const res2 = await axios.get(`${process.env.REACT_APP_BASE_API}/event/${id}/?token=${process.env.REACT_APP_TOKEN_BASE_API}`);

//             let d = new Date(eventRecord.releaseTime).getTime()

//             let currentDate = new Date().getTime()
//             console.log('resres', 'current:', currentDate, 'event date', d)

//                 if (d > currentDate) {
//                     dispatach(setAlert('Stats Not available as event start date is ' + new Date(eventRecord.releaseTime), 'error', 3000))
//                     dispatach({ type: StatsConstant.SET_LOADING_FALSE, payload: false })
//                 }
//             else if (d < currentDate) {

//                 let cD = moment(eventRecord.releaseTime).format('L');
//                 console.log('start', cD, currentDate)
//                 let year = cD.substring(6, 10);
//                 let month = cD.substring(0, 2);
//                 let d1 = cD.substring(3, 5);
//                 let start_date = year + '-' + month + '-' + d1
//                 console.log('start start', start_date)
//                 const res = await axios.get(`${process.env.REACT_APP_STATS_API_URL}/event/${id}/?token=${process.env.REACT_APP_TOKEN}&scope=all&dateFrom=${start_date}&dateTo=today`);

//                 console.log('resres', cD)
//                 let TempGeoData = [];
//                 let countries = res.data.arrGeographCountries
//                 let counts = res.data.arrGeographPerc
//                 var totalLength = countries.length;
//                 var i = 0;

//                 while (totalLength > 0) {
//                     TempGeoData.push([countries[i], counts[i]]);
//                     totalLength--;
//                     i++;
//                 }

//                 dispatach({
//                     type: StatsConstant.SET_GLOBAL_FILTER,
//                     payload: { eventOrCompany: 'event', searchText: eventRecord.title }
//                 })

//                 // Store all stats by ID
//                 dispatach({
//                     type: StatsConstant.GET_ALL_STATS_BY_EVENTID,
//                     payload: { data: res.data, eventStart: eventRecord.releaseTime, eventEnd: eventRecord.endTime, eventId: eventRecord._id }
//                 })
//                 // Store all GEO DATA for easy access
//                 dispatach({
//                     type: StatsConstant.SET_GEO_DATA,
//                     payload: TempGeoData
//                 })
//             }

//         } catch (error) {
//             console.error(error)
//             dispatach({
//                 type: StatsConstant.SET_ERROR,
//                 payload: error
//             })

//         }

//     }
// }

// get stats by id and date range
// export const getStatByIDAndDates = (id, start, end) => {

//     return async (dispatach) => {

//         dispatach({
//             type: StatsConstant.SET_LOADING,
//             payload: true
//         })

//         try {

//             const res = await axios.get(`${process.env.REACT_APP_STATS_API_URL}/event/${id}/?token=${process.env.REACT_APP_TOKEN}&sort=-uniquePageviews&scope=all&dateFrom=${start}&dateTo=${end}`);
//             const res2 = await axios.get(`${process.env.REACT_APP_BASE_API}/event/${id}/?token=${process.env.REACT_APP_TOKEN_BASE_API}`);

//             dispatach({
//                 type: StatsConstant.SET_GLOBAL_FILTER,
//                 payload: { eventOrCompany: 'event', searchText: eventRecord.title }
//             })
//             let TempGeoData = [];
//             let countries = res.data.arrGeographCountries
//             let counts = res.data.arrGeographPerc
//             var totalLength = countries.length;
//             var i = 0;

//             while (totalLength > 0) {
//                 TempGeoData.push([countries[i], counts[i]]);
//                 totalLength--;
//                 i++;
//             }

//             // Store all stats by ID
//             dispatach({
//                 type: StatsConstant.GET_ALL_STATS_BY_EVENTID,
//                 payload: { data: res.data, eventStart: eventRecord.releaseTime, eventEnd: eventRecord.endTime, eventId: eventRecord._id }

//             })

//             // Store all GEO DATA for easy access
//             dispatach({
//                 type: StatsConstant.SET_GEO_DATA,
//                 payload: TempGeoData
//             })

//             dispatach(getRegistrantDetailsByDates(id, start, end))

//         } catch (error) {
//             console.error(error)
//             dispatach({
//                 type: StatsConstant.SET_ERROR,
//                 payload: error
//             })

//         }

//     }
// }

// Stats by ID
export const getStatByID = (id) => {
  return async (dispatach) => {
    dispatach({
      type: StatsConstant.SET_LOADING,
      payload: true,
    });


 

    try {
      const eventRecord = await fetchEventById(id);
      if(eventRecord.source === 'bc') {

        dispatach(resetStats())
        dispatach(setGlobalFilter('event', eventRecord.title))
          dispatach({
            type:StatsConstant.SET_EVENT_TYPE,
            payload:'bc'
          })

          const res2 = await axios.get(
            `${process.env.REACT_APP_STATS_API_URL}/event/getStatsByPlayerID/${eventRecord.media.bcVideoId}/?token=${process.env.REACT_APP_TOKEN_BASE_API}`
          );

            
          dispatach({
            type:StatsConstant.GET_ALL_STATS_BY_EVENTID_BRIGHTCOVE,
            payload:{
              eventID: eventRecord._id,
              geo: res2.data.country,
              device:res2.data.stats_device,
              views:res2.data.views,
              stats_referrer_domain:res2.data.stats_referrer_domain

            }
          })

          console.log('res2.data', res2.data)




      } else {
        try {
          //Stats API - For analytics
          const res = await axios.get(
            `${process.env.REACT_APP_STATS_API_URL}/users/${id}/?token=${process.env.REACT_APP_TOKEN}`
          );
    
          //Stats API - For Geo data
          const res3 = await axios.get(
            `${process.env.REACT_APP_STATS_API_URL}/event/allGeoData/${id}/?token=${process.env.REACT_APP_TOKEN}`
          );
    
          //Stats API - For Device information
          const res4 = await axios.get(
            `${process.env.REACT_APP_STATS_API_URL}/event/allDeviceInformation/${id}/?token=${process.env.REACT_APP_TOKEN}`
          );
    
    
          dispatach({ type: SET_LOADING_GRAPH, payload: true });
          dispatach(getRegCount(id))
    
          //Stats API - For Graph data
          const res5 = await axios.get(
            `${process.env.REACT_APP_STATS_API_URL}/users/dateRange/${id}/?token=${process.env.REACT_APP_TOKEN}`
          );
    
          console.log("Graph data", res5.data);
          if (!eventRecord.registrationRequired) {
            console.log("Event with no Req", id);
            dispatach(getStatByIDNoReq(id));
          } 
          else {
            //  console.log('Geo data', res3.data)
            let d = new Date(eventRecord.releaseTime).getTime();
    
            //Check event was live and stopped
            // liveEnded -0
            // liveStarted - 1
            let liveEnded = String(eventRecord.liveEnded);
            let liveStarted = String(eventRecord.liveStarted);
            let event;
            if (liveStarted === "1" && liveEnded === "0") {
              event = "live";
            } else if (liveStarted === "0" && liveEnded === "1") {
              event = "stopped";
            } else if (!res.data.isLive) {
              event = "ondemand";
            }
    
            let currentDate = new Date().getTime();
    
            if (d > currentDate) {
              dispatach(
                setAlert(
                  "Stats Not available as event start date is " +
                    new Date(eventRecord.releaseTime),
                  "error",
                  3000
                )
              );
              dispatach({ type: StatsConstant.SET_LOADING_FALSE, payload: false });
    
              dispatach({
                type: StatsConstant.SET_GLOBAL_FILTER,
                payload: {
                  eventOrCompany: "event",
                  searchText: res.data.eventTitle,
                },
              });
    
              // Store all stats by ID
              dispatach({
                type: StatsConstant.GET_ALL_STATS_BY_EVENTID,
                payload: {
                  data: res.data,
                  eventReleaseTime:eventRecord.releaseTime,
                  eventType:eventRecord.source,
                  eventStartDate: new Date(eventRecord.releaseTime),
                  eventEndDate: new Date(),
                  geo: res3.data,
                  isLive: res.data.isLive,
                  liveStartTime: res.data.EventStartedAt,
                  event: event,
                  graph: res5.data,
                  eventData:eventRecord
                },
              });
            } else {
              dispatach({
                type: StatsConstant.SET_GLOBAL_FILTER,
                payload: {
                  eventOrCompany: "event",
                  searchText: res.data.eventTitle,
                },
              });
    
              // Store all stats by ID
              dispatach({
                type: StatsConstant.GET_ALL_STATS_BY_EVENTID,
                payload: {
                  data: res.data,
                  eventReleaseTime:eventRecord.releaseTime,

                  eventType:eventRecord.source,
                  eventStartDate: new Date(eventRecord.releaseTime),
                  eventEndDate: new Date(),
                  geo: res3.data,
                  device: res4.data,
                  isLive: res.data.isLive,
                  liveStartTime: res.data.EventStartedAt,
                  event: event,
                  graph: res5.data,
                  eventData:eventRecord
    
                },
              });
            }
          }
    
        } catch (error) {
          console.error(error);
          dispatach({
            type: StatsConstant.SET_ERROR,
            payload: error,
          });
        }
      }
      
    } catch (error) {
        const data = error.response?.data;
        const message =
          (typeof data === "string" && data) ||
          data?.error ||
          "Could not load this event";
        dispatach(setAlert(message, "error", 5000));
        dispatach({ type: SET_LOADING_FALSE, payload: false });
        dispatach({
          type: StatsConstant.SET_ERROR,
          payload: message,
        });
    }

  };
};

// Stats by ID
export const getStatByIDAndDates = (id, start, end) => {
  return async (dispatach) => {
    dispatach({
      type: StatsConstant.SET_LOADING,
      payload: true,
    });

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/users/${id}/?token=${process.env.REACT_APP_TOKEN}&sDate=${start}&eDate=${end}`
      );

      const eventRecord = await fetchEventById(id);

          //Stats API - For Geo data
    const res3 = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/event/allGeoData/${id}/?token=${process.env.REACT_APP_TOKEN}`
      );

      //Stats API - For Device information
      const res4 = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/event/allDeviceInformation/${id}/?token=${process.env.REACT_APP_TOKEN}`
      );


      dispatach({ type: SET_LOADING_GRAPH, payload: true });


      //Stats API - For Graph data
      const res5 = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/users/dateRange/${id}/?token=${process.env.REACT_APP_TOKEN}&sDate=${start}&eDate=${end}`
      );


      let d = new Date(eventRecord.releaseTime).getTime();

      let currentDate = new Date().getTime();

      if (d > currentDate) {
        dispatach(
          setAlert(
            "Stats Not available as event start date is " +
              new Date(eventRecord.releaseTime),
            "error",
            3000
          )
        );
        dispatach({ type: StatsConstant.SET_LOADING_FALSE, payload: false });
      } else {

      console.log("Graph data", res5.data);
      if (!eventRecord.registrationRequired) {
        console.log("Event with no Req", id);
        dispatach(getStatByIDNoReq(id));
      } else {
        //  console.log('Geo data', res3.data)
        let d = new Date(eventRecord.releaseTime).getTime();

        //Check event was live and stopped
        // liveEnded -0
        // liveStarted - 1
        let liveEnded = String(eventRecord.liveEnded);
        let liveStarted = String(eventRecord.liveStarted);
        let event;
        if (liveStarted === "1" && liveEnded === "0") {
          event = "live";
        } else if (liveStarted === "0" && liveEnded === "1") {
          event = "stopped";
        } else if (!res.data.isLive) {
          event = "ondemand";
        }

        let currentDate = new Date().getTime();

        if (d > currentDate) {
          dispatach(
            setAlert(
              "Stats Not available as event start date is " +
                new Date(eventRecord.releaseTime),
              "error",
              3000
            )
          );
          dispatach({ type: StatsConstant.SET_LOADING_FALSE, payload: false });

          dispatach({
            type: StatsConstant.SET_GLOBAL_FILTER,
            payload: {
              eventOrCompany: "event",
              searchText: res.data.eventTitle,
            },
          });

          // Store all stats by ID
          dispatach({
            type: StatsConstant.GET_ALL_STATS_BY_EVENTID,
            payload: {
              data: res.data,
              eventReleaseTime:eventRecord.releaseTime,

              eventType:eventRecord.source,
              eventStartDate: new Date(eventRecord.releaseTime),
              eventEndDate: new Date(),
              geo: res3.data,
              isLive: res.data.isLive,
              liveStartTime: res.data.EventStartedAt,
              event: event,
              graph: res5.data,
              dateRangeStart:start,
              dateRangeEnd:end
            },
          });
        } else {
          dispatach({
            type: StatsConstant.SET_GLOBAL_FILTER,
            payload: {
              eventOrCompany: "event",
              searchText: res.data.eventTitle,
            },
          });

          // Store all stats by ID
          dispatach({
            type: StatsConstant.GET_ALL_STATS_BY_EVENTID,
            payload: {
              data: res.data,
              eventReleaseTime:eventRecord.releaseTime,

              eventType:eventRecord.source,
              eventStartDate: new Date(eventRecord.releaseTime),
              eventEndDate: new Date(),
              geo: res3.data,
              device: res4.data,
              isLive: res.data.isLive,
              liveStartTime: res.data.EventStartedAt,
              event: event,
              graph: res5.data,
              dateRangeStart:start,
              dateRangeEnd:end

            },
          });
        }
      }
      }

      // dispatach({
      //     type: StatsConstant.SET_GLOBAL_FILTER,
      //     payload: { eventOrCompany: 'event', searchText: res.data.eventTitle }
      // })

      // // Store all stats by ID
      // dispatach({
      //     type: StatsConstant.GET_ALL_STATS_BY_EVENTID,
      //     payload: res.data
      // })
    } catch (error) {
      console.error(error);
      dispatach({
        type: StatsConstant.SET_ERROR,
        payload: error,
      });
    }
  };
};

// Stats for Event with NoReq

//NoReq Live user
export const getLiveUsersByEventIDNoReq = (id) => {
  return async (dispatach) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/event/fetchLiveUsersNoReq/${id}/?token=${process.env.REACT_APP_TOKEN}`
      );
      dispatach({
        type: StatsConstant.GET_RT_STATS_BY_EVENTID_NO_REG,
        payload: res.data,
      });
    } catch (error) {
      console.error(error);
      dispatach({
        type: StatsConstant.SET_ERROR,
        payload: error,
      });
    }
  };
};

//NoReq StatsById
export const getStatByIDNoReq = (id) => {
  return async (dispatach) => {
    dispatach({
      type: StatsConstant.SET_LOADING,
      payload: true,
    });

    try {
      //Stats API - For analytics
      const res = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/users/noReq/${id}/?token=${process.env.REACT_APP_TOKEN}`
      );

      const eventRecord = await fetchEventById(id);

      //Stats API - For Geo data
      const res3 = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/event/allGeoDataNoReq/${id}/?token=${process.env.REACT_APP_TOKEN}`
      );

      //Stats API - For Device information
      const res4 = await axios.get(
        `${process.env.REACT_APP_STATS_API_URL}/event/allDeviceInformationNoReq/${id}/?token=${process.env.REACT_APP_TOKEN}`
      );

      //  console.log('Geo data', res3.data)
      let d = new Date(eventRecord.releaseTime).getTime();

      //Check event was live and stopped
      // liveEnded -0
      // liveStarted - 1
      let liveEnded = String(eventRecord.liveEnded);
      let liveStarted = String(eventRecord.liveStarted);
      let event;
      if (liveStarted === "1" && liveEnded === "0") {
        event = "live";
      } else if (liveStarted === "0" && liveEnded === "1") {
        event = "stopped";
      } else if (!res.data.isLive) {
        event = "ondemand";
      }

      let currentDate = new Date().getTime();

      if (d > currentDate) {
        dispatach(
          setAlert(
            "Stats Not available as event start date is " +
              new Date(eventRecord.releaseTime),
            "error",
            3000
          )
        );
        dispatach({ type: StatsConstant.SET_LOADING_FALSE, payload: false });

        dispatach({
          type: StatsConstant.SET_GLOBAL_FILTER,
          payload: { eventOrCompany: "event", searchText: res.data.eventTitle },
        });

        // Store all stats by ID
        dispatach({
          type: StatsConstant.GET_ALL_STATS_BY_EVENTID_NO_REG,
          payload: {
            data: res.data,
            eventStartDate: new Date(eventRecord.releaseTime),
            eventEndDate: new Date(),
            geo: res3.data,
            isLive: res.data.isLive,
            liveStartTime: res.data.EventStartedAt,
            event: event,
            eventData:eventRecord
          },
        });
      } else {
        dispatach({
          type: StatsConstant.SET_GLOBAL_FILTER,
          payload: { eventOrCompany: "event", searchText: res.data.eventTitle },
        });

        // Store all stats by ID
        dispatach({
          type: StatsConstant.GET_ALL_STATS_BY_EVENTID_NO_REG,
          payload: {
            data: res.data,
            eventStartDate: new Date(eventRecord.releaseTime),
            eventEndDate: new Date(),
            geo: res3.data,
            device: res4.data,
            isLive: res.data.isLive,
            liveStartTime: res.data.EventStartedAt,
            event: event,
            eventData:eventRecord
          },
        });
      }
    } catch (error) {
      console.error(error);
      dispatach({
        type: StatsConstant.SET_ERROR,
        payload: error,
      });
    }
  };
};

//NoReq StatsByIDandDates

export const setLoading = () => (dispatch) =>
  dispatch({
    type: SET_LOADING,
    payload: true,
  });



export const setLoadingForGraph = () => (dispatch) =>
  dispatch({
    type: SET_LOADING_GRAPH,
    payload: true,
  });
